import { render, staticRenderFns } from "./ViewDialog.vue?vue&type=template&id=4150aea2&scoped=true"
import script from "./ViewDialog.vue?vue&type=script&lang=js"
export * from "./ViewDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewDialog.vue?vue&type=style&index=0&id=4150aea2&prod&lang=css"
import style1 from "./ViewDialog.vue?vue&type=style&index=1&id=4150aea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150aea2",
  null
  
)

export default component.exports